import { caseLifecycleTypes, debtorUpdateTypes, documentTypes, economyTypes, importTypes, interactionTypes, paymentPlanTypes, settingTypes, tribunalTypes, workflowTypes, } from '@debbie/common/dist/blamelog/index.js';
import { useBlameLogs } from '@debbie/cortex/dist/blamelogs/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import RemoteTable from '../RemoteTable.js';
import { CaseLifecycleDetails, DebtorUpdateDetails, DocumentDetails, ImportDetails, InteractionDetails, PaymentPlanDetails, SettingsDetails, TribunalDetails, VoucherDetails, WorkflowDetails, } from './details/index.js';
export const BlameLogList = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null, React.createElement(RemoteTable, { useFetch: (filter, page, pageSize) => {
            return useBlameLogs(props.refType, props.refId, { types: props.types }, page, pageSize);
        }, pageSize: 25, initFilters: {}, genKey: (bl) => bl.id, sortKeyKey: "fake", sortDirectionKey: "fake", values: {
            performedBy: {
                label: '',
                map: (p) => React.createElement(PerformedBy, { performedBy: p }),
                sortable: false,
            },
            type: {
                label: '',
                map: (type) => lang.blameLogSimplfiedType[type],
                sortable: false,
            },
            loggedAt: {
                label: '',
                map: (loggedAt) => (React.createElement("small", null, moment(loggedAt).format(THEME.DATE_FORMAT_LONG))),
                sortable: false,
            },
            details: {
                label: '',
                map: (details, a) => {
                    if (economyTypes.includes(a.type)) {
                        return React.createElement(VoucherDetails, { blamelog: a });
                    }
                    if (interactionTypes.includes(a.type)) {
                        return React.createElement(InteractionDetails, { blamelog: a });
                    }
                    if (workflowTypes.includes(a.type)) {
                        return React.createElement(WorkflowDetails, { blamelog: a });
                    }
                    if (settingTypes.includes(a.type)) {
                        return React.createElement(SettingsDetails, { blamelog: a });
                    }
                    if (debtorUpdateTypes.includes(a.type)) {
                        return React.createElement(DebtorUpdateDetails, { blamelog: a });
                    }
                    if (caseLifecycleTypes.includes(a.type)) {
                        return React.createElement(CaseLifecycleDetails, { blamelog: a });
                    }
                    if (paymentPlanTypes.includes(a.type)) {
                        return React.createElement(PaymentPlanDetails, { blamelog: a });
                    }
                    if (tribunalTypes.includes(a.type)) {
                        return React.createElement(TribunalDetails, { blamelog: a });
                    }
                    if (documentTypes.includes(a.type)) {
                        return React.createElement(DocumentDetails, { blamelog: a });
                    }
                    if (importTypes.includes(a.type)) {
                        return React.createElement(ImportDetails, { blamelog: a });
                    }
                    return `${details}`;
                },
                sortable: false,
            },
        } })));
};
//# sourceMappingURL=BlameLogList.js.map